package eu.bontlab.styles

import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.transitionDuration
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms

val BackToTopButtonStyle = CssStyle {
    base {
        Modifier
            .rotate(a = 180.deg)
            .transition {
                property("rotate")
            }
            .styleModifier {
                transitionDuration(200.ms)
            }
    }
    hover {
        Modifier.rotate(a = 0.deg)
    }
}